module.exports = __webpack_public_path__ + "static/media/curatorial-2.f3ecf584.jpg";